import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PaperHeader.scss';
import { headerStyle, getThemeFromLocalStorage } from '../utils/utils';

class PaperHeader extends Component {
  state = {
    colors: 'normal',
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    this.setState({ colors });
  }

  render() {
    return (
      <div className="title-header" style={{ backgroundColor: headerStyle[this.state.colors].backgroundColor, color: headerStyle[this.state.colors].color }}>
        <h3>{this.props.title}</h3>
        <h5>{this.props.text}</h5>
      </div>
    );
  }
}

PaperHeader.propTypes = {
  title: React.PropTypes.string,
  text: React.PropTypes.string,
};

export default withStyles(s)(PaperHeader);



// WEBPACK FOOTER //
// src/components/PaperHeader/PaperHeader.js